import {assertAndContinue} from 'Asserts';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {StructuredTableKind} from 'notebook/structured-tables/StructuredTableConstants';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import {FolderItemIcon} from 'ui-library/icons/IconConstants';
import {assertNever} from 'util/Types';

/**
 * For a given StructuredTableKind, return the icon that generally represents that table kind.
 *
 * If you are getting the icon of a particular table instance, you probably shouldn't be using this.
 * Instead, use StructuredTableAdapter.getTableIcon() which takes into account any additional overrides the
 * table might have for its icon.
 */
export default function kindToIcon(kind: StructuredTableKind): BenchlingIconName {
  switch (kind) {
    case StructuredTableKind.MIXTURE_METADATA:
    case StructuredTableKind.MIXTURE_INGREDIENTS:
      return FolderItemIcon.Mixture;
    case StructuredTableKind.INVENTORY:
      return ModelTypeConstants.LOCATION;
    case StructuredTableKind.PLATE_CREATION:
      return ModelTypeConstants.PLATE;
    case StructuredTableKind.BOX_CREATION:
      return ModelTypeConstants.BOX;
    case StructuredTableKind.RUN_OUTPUT_SAMPLES:
      return ModelTypeConstants.SAMPLE;
    case StructuredTableKind.REGISTRATION:
      return 'register';
    case StructuredTableKind.RESULTS:
      return 'table';
    case StructuredTableKind.TRANSFER:
      return 'transfer';
    case StructuredTableKind.PROCESS_OUTPUT:
      return 'process-output';
    case StructuredTableKind.PROCESS_TASK:
      return 'process-task';
    case StructuredTableKind.LOOKUP:
      return 'search';
    case StructuredTableKind.FILL_PLATE_TRANSFER_SUMMARY_VIEW:
    case StructuredTableKind.FILL_PLATE_TRANSFER_WELL_VIEW:
    case StructuredTableKind.FILL_PLATE_TRANSFER_PLATE_RECORD:
      return ModelTypeConstants.PLATE;
    case StructuredTableKind.BULK_ASSEMBLY_FRAGMENTS:
      return FolderItemIcon.Sequence;
    case StructuredTableKind.BULK_ASSEMBLY_CONSTRUCTS:
      return 'assembly-v2';
    case StructuredTableKind.BULK_ASSEMBLY_PRIMERS:
      return FolderItemIcon.OligoV2;
    case StructuredTableKind.APP_CANVAS:
      return 'table';
    case StructuredTableKind.PARAMETER:
      return 'table';
    case StructuredTableKind.PROCEDURE_MATERIAL_INPUTS:
      return 'material-input';
    case StructuredTableKind.PROCEDURE_MATERIAL_OUTPUTS:
      return 'material-output';
    case StructuredTableKind.PROCEDURE_DATA_PARAMETERS_CONFIG:
      return 'parameters';
    case StructuredTableKind.PROCEDURE_EQUIPMENT:
      return 'microscope';
    case StructuredTableKind.TEST_DEFINITIONS:
      return 'table';
    case StructuredTableKind.STOICHIOMETRY:
      return 'ochem-molecule-beaker';
    default:
      assertAndContinue(false, `Unexpected kind "${assertNever(kind)}"`);
      return 'table';
  }
}
